import Dialog from 'jitsi/base/ui/components/web/Dialog';
import React from 'react';
import { useTranslation } from 'react-i18next';
export const HangupDialog = ({ onSubmit }) => {
    const { t } = useTranslation();
    return (React.createElement(Dialog, { onSubmit: onSubmit, hideCloseButton: true, titleKey: 'toolbar.hangup.title', ok: { translationKey: 'dialog.confirm' } }, t('toolbar.hangup.description')));
};
